import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import { Card, Grid } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

export default class SocialMedia extends Component {
  state = {
    items: [],
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    per_page: 20,
    page_no: 1,
    notiColor: "success",
    notification: false,
    message: "",
    loading: false,
  };

  componentDidMount() {
    this.getAllSocialMedia(this.state.page_no, this.state.per_page);
  }

  getAllSocialMedia = (page = 1, limit = 20) => {
    this.setState({ loading: true });

    if (init() !== "success") {
      this.setState({ loading: false });
      return;
    }

    axios
      .get(`${Constants.getUrls.getSocialMedia}?page=${page}&limit=${limit}`)
      .then((resp) => {
        // Expected shape from our API:
        // { status: true, data: [...], pagination: { page, limit, total, pages } }
        const apiPagination = resp.data?.pagination || {};
        const docs = resp.data?.data || [];

        this.setState({
          items: Array.isArray(docs) ? docs : [],
          pagination: {
            page: apiPagination.page || page,
            totalPages: apiPagination.pages || 1,
            hasNextPage:
              apiPagination.page && apiPagination.pages
                ? apiPagination.page < apiPagination.pages
                : false,
            hasPrevPage: apiPagination.page ? apiPagination.page > 1 : false,
            nextPage:
              apiPagination.page && apiPagination.pages
                ? apiPagination.page < apiPagination.pages
                  ? apiPagination.page + 1
                  : null
                : null,
            prevPage: apiPagination.page && apiPagination.page > 1 ? apiPagination.page - 1 : null,
            totalDocs: apiPagination.total || docs.length,
            limit: apiPagination.limit || limit,
          },
          page_no: apiPagination.page || page,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          notiColor: "warning",
          message: err?.response?.data?.message || "Failed to load social media links",
          notification: true,
          loading: false,
        });
        setTimeout(() => {
          this.setState({
            notification: false,
            message: "",
            notiColor: "success",
          });
        }, 3500);
      });
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState(
      {
        per_page: newLimit,
      },
      () => {
        this.getAllSocialMedia(1, newLimit); // reset to first page
      }
    );
  };

  handlePageChange = (newPage) => {
    this.getAllSocialMedia(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this social media link?")) return;

    if (init() !== "success") {
      return window.location.assign("/signin");
    }

    axios
      .delete(Constants.deleteUrls.deleteSocialMedia + "/" + id)
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp.data?.message || "Social media link deleted",
          },
          () => {
            this.getAllSocialMedia(this.state.page_no, this.state.per_page);
          }
        );
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 2500);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Failed to delete social media link",
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 3500);
      });
  };

  render() {
    const { items, loading, pagination } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Social Media
              </MDTypography>
            </MDBox>

            <Grid item sm={4} px={2} align="right" style={{ padding: 16 }}>
              <Link to="/addsocialmedia">
                <MDButton variant="contained" size="small" color="primary">
                  Add New
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <MDBox>
                  <Grid align="center">
                    <h4>Loading...</h4>
                  </Grid>
                </MDBox>
              ) : items.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "serial", accessor: "serial", width: "6%" },
                      { Header: "icon", accessor: "icon" },
                      { Header: "url", accessor: "url" },
                      { Header: "action", accessor: "action" },
                    ],
                    rows: items.map((item, index) => ({
                      serial: (pagination.page - 1) * pagination.limit + (index + 1),
                      icon: (
                        <img
                          src={Constants.imageDomain + item.icon}
                          alt="Social Icon"
                          style={{
                            height: "40px",
                            width: "40px",
                            objectFit: "contain",
                          }}
                        />
                      ),
                      url: (
                        <a href={item.url} target="_blank" rel="noopener noreferrer">
                          {item.url}
                        </a>
                      ),
                      action: (
                        <>
                          <div>
                            <Link
                              to={{
                                pathname: "/updatesocialmedia/" + item._id,
                                state: { data: item },
                              }}
                            >
                              <MDButton variant="outlined" size="small" color="success">
                                Update
                              </MDButton>
                            </Link>
                          </div>
                          <div style={{ marginTop: "1rem" }}>
                            <MDButton
                              variant="outlined"
                              size="small"
                              color="error"
                              onClick={() => this.handleDelete(item._id)}
                            >
                              Delete
                            </MDButton>
                          </div>
                        </>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  isnextPage={pagination.nextPage}
                  prevPage={pagination.prevPage}
                  totalDocs={pagination.totalDocs}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <div style={{ padding: 16 }}>No Social Media Links Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="VASA | Social Media"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
